import encrypt from "../AESHashing/encrypt";

export default function saveUserDetails(userDetails: any) {
  const encryptedString = encrypt(JSON.stringify(userDetails));
  localStorage.setItem("user_details", encryptedString.toString());
}
